import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Stack, Text } from '@solvhealth/jigsaw';
import Avatar from '../../Account/Profile/Avatar';
import { colors } from '../../../constants/colors';
import { fontFamily, fontSize } from '../../../constants/text';
import Badge from '../../SolvPatternLibrary/Icons/Badge';
import SolvPlusLogo from '~/components/Membership/SolvPlusLogo';
import { UserProfile } from '~/core/dapi/models';
import { RELATIONSHIP_TYPE_CHILD, RELATIONSHIP_TYPE_SELF } from '~/constants';
import { profileCanAccessPremium } from '~/components/Membership/utils';

const StyledListItem = styled(ListItem)`
  & .listItemRoot {
  }
`;

const UnverifiedPrimary = styled.span`
  font-style: italic;
`;

const Name = styled.span`
  color: ${colors.myRightFoot};
  font-family: ${fontFamily.medium};
`;

const Secondary = styled.span`
  color: ${colors.lightText};
  text-transform: capitalize;
  font-size: ${fontSize.mediumSmall};
`;

const TrashCan = styled(DeleteIcon)`
  &.secondary {
    color: ${colors.lightText};
  }
`;

const AvatarBadgeContainer = styled.div`
  position: relative;
`;

const ProfileBadge = styled(Badge)`
  height: 14px;
  width: 14px;
  z-index: 1;
  padding: 2px;
`;

const RightArrow = styled(ListItemSecondaryAction)`
  right: 0;
`;

const useStyles = makeStyles({
  root: {
    padding: '0 16px',
  },
});

type Props = {
  openDeleteProfile?: (...args: any[]) => any;
  isVerified?: boolean;
  isBadged?: boolean;
  profileColor?: string;
  relationshipToAccount?: string;
  showTrashCan?: boolean;
  userProfile?: UserProfile;
  showRightArrow?: boolean;
  showPlusLogo?: boolean;
};

const ProfileListRow = (props: Props) => {
  const {
    isBadged,
    isVerified,
    profileColor,
    relationshipToAccount,
    userProfile,
    showTrashCan,
    openDeleteProfile,
    showRightArrow,
    showPlusLogo,
  } = props;
  const listItemTextStyles = useStyles();

  const handleDeleteClick = (e: any) => {
    e && e.stopPropagation();

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    openDeleteProfile(userProfile);
  };

  return (
    <StyledListItem button classes={{ root: 'listItemRoot' }}>
      <AvatarBadgeContainer>
        {isBadged && <ProfileBadge />}

        <Avatar profileColor={profileColor} userProfile={userProfile} />
      </AvatarBadgeContainer>

      <ListItemText
        classes={{
          root: listItemTextStyles.root,
        }}
        primary={
          isVerified ? (
            <Stack alignItems="center" row space={1}>
              <Text variant="subtitle">
                {userProfile?.first_name} {userProfile?.last_name}
              </Text>
              {showPlusLogo && profileCanAccessPremium(userProfile) && (
                <img height="18px" src="/images/membership/logo_flat.svg" />
              )}
            </Stack>
          ) : (
            <UnverifiedPrimary>Unverified Profile</UnverifiedPrimary>
          )
        }
        secondary={<Secondary>{relationshipToAccount}</Secondary>}
      />
      {showRightArrow && (
        <RightArrow>
          <IconButton aria-label="arrow">
            <ChevronRightIcon style={{ color: colors.squid }} />
          </IconButton>
        </RightArrow>
      )}
      {showTrashCan && (
        <ListItemSecondaryAction onClick={handleDeleteClick}>
          <IconButton aria-label="Delete">
            <TrashCan classes={{ colorSecondary: 'secondary' }} />
          </IconButton>
        </ListItemSecondaryAction>
      )}
    </StyledListItem>
  );
};

export default ProfileListRow;
